
import { Link, useLocation } from 'react-router-dom';

type NavbarLinkProps = {
  to: string;
  isActive?: boolean;
  text: string;
  mobile?: boolean;
  onClick?: () => void;
  className?: string;
};

const NavbarLink = ({ to, isActive, text, mobile = false, onClick, className = '' }: NavbarLinkProps) => {
  const location = useLocation();
  const computedIsActive = isActive !== undefined ? isActive : location.pathname === to;
  
  return (
    <Link
      to={to}
      className={`font-medium transition-colors ${
        computedIsActive ? 'text-autocare-blue' : 'text-foreground hover:text-autocare-blue'
      } ${mobile ? 'block px-3 py-2 text-base' : ''} ${className}`}
      onClick={onClick}
    >
      {text}
    </Link>
  );
};

export default NavbarLink;
